<template>
    <el-menu
      default-active="analysis"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      :router="true"
      active-text-color="#ffd04b">
      <el-menu-item index="list">
        <i class="el-icon-setting"></i>
        <span slot="title">城市列表</span>
      </el-menu-item>
      <el-menu-item index="analysis">
        <i class="el-icon-menu"></i>
        <span slot="title">数据分析</span>
      </el-menu-item>
      <el-menu-item index="3" disabled>
        <i class="el-icon-document"></i>
        <span slot="title">使用文档</span>
      </el-menu-item>
      <el-menu-item index="4" disabled>
        <i class="el-icon-user"></i>
        <span slot="title">用户中心</span>
      </el-menu-item>
    </el-menu>
</template>

<script>
export default {
  name: 'AdminAside',
  created() {
    if (this.$route.name !== 'analysis') {
      this.$router.push({
        name: 'analysis',
      })
    }
  }
}
</script>

<style lang="less">
  .el-menu-vertical-demo {
    box-sizing: border-box;
    padding-top: 30px;
  }
</style>